import React from 'react'

const BlackberryAbout = () => {
    return (
        <div>
            <h1>ABout page Blackberry 123</h1>
        </div>
    )
}

export default BlackberryAbout;